import type {
  BuildFinancialStatementReportRequest,
  FinancialStatementConfiguration,
  FinancialStatementGeneralSettings,
} from "../../../../../../../../api/types/svTypes.ts";

const getBuildSettings = (settings: FinancialStatementGeneralSettings): FinancialStatementGeneralSettings => ({
  ...settings,
  detailedView: false,
  highlightPeriod: false,
  showNegativesInRed: true,
});

export const getBuildInputs = (
  configuration: FinancialStatementConfiguration | undefined,
  conditions: BuildFinancialStatementReportRequest["conditions"]
) => ({
  conditions,
  lines: configuration?.lines ?? [],
  axes: configuration?.columns.axes ?? [],
  dataColumns: configuration?.columns.dataColumns ?? [],
  settings: configuration ? getBuildSettings(configuration.settings) : {},
});
